import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'
import { FraudSuspensionFallback } from '@/components/error-boundaries/fallbacks/fraud-suspension-fallback'
import { GenericErrorFallback } from '@/components/error-boundaries/fallbacks/generic-error-fallback'
import { LayoutSkeleton } from '@/components/layout/layout-skeleton'
import { SidebarProvider } from '@/components/sv/sidebar'
import { FraudSuspensionError } from '@/lib/errors'

const fallbackRender = ({ error, resetErrorBoundary }: FallbackProps) => {
  const isFraudSuspensionError =
    error.name === 'FraudSuspensionError' ||
    error instanceof FraudSuspensionError
  return (
    <SidebarProvider>
      <LayoutSkeleton>
        {isFraudSuspensionError ? (
          <FraudSuspensionFallback />
        ) : (
          <GenericErrorFallback
            error={error}
            resetErrorBoundary={resetErrorBoundary}
          />
        )}
      </LayoutSkeleton>
    </SidebarProvider>
  )
}

export const RootErrorBoundary = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <ErrorBoundary
      fallbackRender={fallbackRender}
      onReset={() => {
        window.location.href = window.location.origin
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
